import React, { Fragment } from 'react'
import {  Container, Header } from 'semantic-ui-react'
import ButtonAwesome from '../Core/ButtonAwesome'

/**
* @author
* @function TheGoldenQueries
**/

const TheGoldenQueries = ({onQueryButtonClicked}) => {
  return(
    <Fragment>
        <Container textAlign="center">
            <Header textAlign = "center" style = {{color : "#C7C11A"}} as="h1">The Golden Queries</Header>
            {[1].map(but => <ButtonAwesome onQueryButtonClicked ={onQueryButtonClicked}/>)}
        </Container>
        
    </Fragment>
   )

 }

export default TheGoldenQueries